var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgAllAudioOff = function SvgAllAudioOff(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    style: {
      enableBackground: "new 0 0 24 24"
    },
    xmlSpace: "preserve"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "all_audio_off_svg__st0",
    d: "M12 0C5.4 0 0 5.4 0 12s5.4 12 12 12 12-5.4 12-12S18.6 0 12 0zM1.5 12c0-2.7 1-5.2 2.7-7l5.1 5v2c0 1.5 1.2 2.8 2.7 2.8.6 0 1.1-.2 1.5-.5l.7.7c-.7.5-1.5.8-2.4.8-1.9-.1-3.4-1.9-3.4-3.9v-1c0-.4-.3-.7-.7-.7s-.7.2-.7.6v.9c0 2.6 1.8 5 4.3 5.3v1h-1.1c-.5 0-.9.4-.9 1 0 .2.2.4.5.4h4.5c.2 0 .4-.2.5-.4 0-.5-.4-1-.9-1h-1.1v-1c1-.1 1.8-.6 2.5-1.2l3.8 3.8c-1.9 1.7-4.3 2.7-7 2.7-5.9.2-10.6-4.5-10.6-10.3zm18.6 6.7L5.3 3.9C7.1 2.4 9.4 1.5 12 1.5c5.8 0 10.5 4.7 10.5 10.5 0 2.6-.9 4.9-2.4 6.7z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "all_audio_off_svg__st0",
    d: "M16.8 13.4c.1-.4.2-.9.2-1.4v-1.2c0-.4-.3-.7-.7-.7s-.7.3-.7.7v1.4l1.2 1.2zM14.7 11.3v-4c0-1.6-1.2-2.8-2.7-2.8-1.1 0-2 .7-2.5 1.6l5.2 5.2z"
  })));
};
export default SvgAllAudioOff;